{
	"actions": {
		"cancel": "Cancel",
		"change": "Change",
		"confirm": "Save the change",
		"saving": "Saving…",
		"use_default": "Use the instance default"
	},
	"field": {
		"in_force": "In force",
		"instance_default_inline": "Instance default: {{value}}"
	},
	"internal_link": {
		"choice": {
			"editor": "Can edit",
			"editor_help": "Anyone in the organization with the link can view or edit.",
			"off": "Off",
			"off_help": "Nobody can open a file or folder to the organization. Those already open stop giving access; people added keep theirs.",
			"viewer": "Can view",
			"viewer_help": "Anyone in the organization with the link can view, at most."
		},
		"description": "Whether a file or folder can be opened to everyone in the organization with its link, and with which role at most.",
		"saved": "The rule for links within the organization was changed.",
		"title": "Links within the organization"
	},
	"offline": {
		"description": "The rules cannot be read while the browser is offline. Nothing has changed; this page fills in as soon as the connection is back.",
		"title": "No connection"
	},
	"page_title": "Policies",
	"public_links": {
		"allow": {
			"detail": "Whoever opens a link sees and downloads only what the link exposes.",
			"detail_off": "Nobody can create new links. Existing ones are suspended, not deleted.",
			"saved_off": "Public links are turned off.",
			"saved_on": "Public links are allowed.",
			"title": "Allow public links"
		},
		"default_expiry": {
			"detail": "What a new link gets when its creator does not choose one.",
			"saved": "The default link expiry has been changed.",
			"title": "Default expiry"
		},
		"description": "A public link opens a file or folder to anyone who receives it, even without an account.",
		"disable_dialog": {
			"cancel": "Cancel",
			"confirm": "Turn off",
			"consequence": {
				"description": "Links already created stop working and stay in \"Active links\", marked \"Blocked by policy\". If you turn this rule back on, they work again on their own.",
				"title": "No link is deleted"
			},
			"description": "Nobody in the organization will be able to create public links.",
			"title": "Turn off public links?"
		},
		"max_expiry": {
			"days_one": "{{count, number}} day",
			"days_other": "{{count, number}} days",
			"detail": "The limit for new links. It does not shorten the ones already created.",
			"saved": "The maximum link expiry was changed.",
			"title": "Maximum duration"
		},
		"needs_expiry": "Available when an expiry is required.",
		"require_expiry": {
			"detail_off": "Whoever creates a link can choose for it never to expire.",
			"detail_on": "Every new link must expire within the maximum duration.",
			"saved_off": "An expiry is no longer required on new links.",
			"saved_on": "Every new link will need an expiry.",
			"title": "Always require an expiry"
		},
		"require_password": {
			"detail": "Applies to new links. Those already active stay as they are.",
			"saved_off": "A password is no longer required on new links.",
			"saved_on": "Every new link will need a password.",
			"title": "Always require a password"
		},
		"title": "Public links"
	},
	"refusal": {
		"insufficient_role": "This rule is not yours to change. Instance-wide settings belong to whoever runs this instance.",
		"unknown_key": "This instance does not evaluate that rule, so nothing was saved. Reload the page and try again.",
		"value_above_ceiling": "This instance allows at most {{max}}. Lower the value and try again: nothing was changed.",
		"value_below_floor": "This instance keeps at least {{min}}. Raise the value and try again: nothing was changed.",
		"value_out_of_bounds": "This instance accepts a value between {{min}} and {{max}}. Nothing was changed.",
		"value_rejected": "This instance does not accept that value. Nothing was changed."
	},
	"retention": {
		"bounds": "This instance accepts between {{min}} and {{max}} days.",
		"card_description": "How long audit events are kept before a scheduled sweep removes them. It is the same number the audit page shows as \"kept for N days.\"",
		"card_title": "Audit retention",
		"confirm_removal": "Shorten and remove",
		"consequence": {
			"counting": "Counting what would be removed…",
			"lengthening": "Nothing is removed, and the longer window applies from now on. Events a previous sweep already took do not come back.",
			"lengthening_title": "Nothing is removed",
			"none": "Nothing on record was created before {{date}}, so today this would remove nothing. The window is still shorter from now on, so events will start being removed sooner.",
			"removal_one": "{{count, number}} event recorded before {{date}} will be permanently removed at the next retention sweep. There is no export to recover it, and nothing in this product can restore it.",
			"removal_other": "{{count, number}} events recorded before {{date}} will be permanently removed at the next retention sweep. There is no export to recover them, and nothing in this product can restore them.",
			"removal_title": "This permanently removes events",
			"uncounted": "Events recorded before {{date}} will be permanently removed at the next sweep and cannot be restored. The count is not available right now, so this cannot say how many."
		},
		"days_one": "{{count, number}} day",
		"days_other": "{{count, number}} days",
		"description": "Events older than this window are removed by a scheduled sweep. Shortening it removes what already falls outside the new window.",
		"field_label": "Days kept",
		"row_bounds": "Between {{min}} and {{max}} days",
		"saved": "The retention window has been changed.",
		"title": "Change audit retention"
	},
	"unavailable": {
		"description": "The rules could not be read. They are unchanged: this is a problem reading them, not with them. Try again in a moment.",
		"title": "Could not read the rules"
	},
	"unrecognized": {
		"description": "A rule this instance evaluates that this screen has no editor for yet. It is shown so you know it is in force."
	},
	"who_can_share": {
		"choice": {
			"everyone": "Editor",
			"everyone_help": "Whoever can edit a file or folder can also share it.",
			"owner_only": "Owner only",
			"owner_only_help": "Only whoever owns a file or folder can share it."
		},
		"description": "The minimum permission needed to share a file or folder with a colleague.",
		"saved": "The sharing rule was changed.",
		"title": "Who can share"
	}
}
